module.exports = __webpack_public_path__ + "static/media/logoCompanyColor.26815c14.svg";